import request from '@/utils/request';

export function fetchList() {
  return request({
    url: 'v1/admin/list',
    method: 'get',
  });
}
